import React, { Component } from 'react';
import './PlayerRow.css';
import UndefinedPhoto from './undefined.png';

class PlayerRow extends Component {
    constructor(props) {
        super(props);
    }



    render() {
        const playerHead = (
            <a data-ng-href={`https://stats.nba.com/player/${this.props.personId}`} sib-player-urls="" team="ai" className="player-headshot ng-isolate-scope" href={`https://stats.nba.com/player/${this.props.personId}`}>
                <sib-img-player className="player-img ng-isolate-scope" type="head" player-id="row.playerId" league-id="ai.profile.leagueId">
                    <img className="player-img" alt="" onError={(e) => { e.target.setAttribute('src', UndefinedPhoto) }} src={`//ak-static.cms.nba.com/wp-content/uploads/headshots/nba/latest/260x190/${this.props.personId}.png`} />
                </sib-img-player>
            </a>
        );
        const playerName = (
            <a data-ng-href={`https://stats.nba.com/player/${this.props.personId}`} sib-player-urls="" team="ai" className="player-name ng-isolate-scope" href={`https://stats.nba.com/player/${this.props.personId}`}>
                <span className="ng-binding">{this.props.firstName}</span>
                <br />
                <span className="ng-binding">{this.props.lastName} <sup>{this.props.pos}</sup></span>
            </a>
        );

        if (this.props.dnp) {
            return (
                <tr>
                    <td className="left player desktop on-court">
                        {playerHead}
                        {playerName}
                    </td>
                    <td className="dnp" colSpan="20">{this.props.dnp}</td>
                </tr>
            );
        }
        return (
            <tr>
                <td className="left player desktop on-court">
                    {playerHead}
                    {playerName}
                </td>
                <td>{this.props.min}</td>
                <td>{this.props.fgm}</td>
                <td>{this.props.fga}</td>
                <td>{this.props.fgp}</td>
                <td>{this.props.tpm}</td>
                <td>{this.props.tpa}</td>
                <td>{this.props.tpp}</td>
                <td>{this.props.ftm}</td>
                <td>{this.props.fta}</td>
                <td>{this.props.ftp}</td>
                <td>{this.props.offReb}</td>
                <td>{this.props.defReb}</td>
                <td>{this.props.totReb}</td>
                <td>{this.props.assists}</td>
                <td>{this.props.turnovers}</td>
                <td>{this.props.steals}</td>
                <td>{this.props.blocks}</td>
                <td>{this.props.pFouls}</td>
                <td>{this.props.points}</td>
                <td>{this.props.plusMinus}</td>
            </tr>
        );
    }
}

export default PlayerRow;